<template>
  <div class="dropdown-fb-control">
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <v-select></v-select>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <dropdown-v2-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <v-select
        v-model="controlValue"
        style="font-size: 14px"
        :style="
          `--bg-color:${properties.pickerBgColor ? properties.pickerBgColor : 'white'};`
        "
        :options="[
          ...superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'options',
            value: properties.options,
            defaultValue: [],
            form: this.form
          }),
          ...(properties.includeOther ? ['Other'] : [])
        ]"
        :multiple="properties.multiselect"
      ></v-select>
      <b-form-input
        class="mt-2"
        v-if="controlValue == 'Other'"
        placeholder="Type value..."
        v-model="localValueOther"
        @blur="controlValueOther = localValueOther"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      {{ controlValueText }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import DropdownV2Properties from "./DropdownV2Properties.vue";
export default {
  name: "DropdownV2",
  components: { DropdownV2Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {},
      localValueOther: ""
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue:
          typeof this.properties.value == "string" &&
          this.properties.value.includes("{{")
            ? this.superComputeFormSubmitterValue({
                elementId: this.id,
                property: "value",
                value: this.properties.value,
                defaultValue: "",
                form: this.form
              })
            : {
                value: this.properties.value,
                otherValue: ""
              }
      });
    }
    this.localValueOther = this.controlValueOther;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true || this.properties.hideOnView)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue != "Other"
              ? (this.controlValue ? this.controlValue : "")
              : this.controlValueOther
          }
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        let value = null;
        if (this.results) value = this.results[this.id];
        else value = this.getFormSubmitterComponentValue(this.id);
        value = value || {
          value: null,
          otherValue: ""
        };
        return value.value;
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const newValue = {
            value: newControlValue,
            otherValue: this.controlValueOther
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueOther: {
      get() {
        let value = null;
        if (this.results) value = this.results[this.id];
        else value = this.getFormSubmitterComponentValue(this.id);
        value = value || {
          value: null,
          otherValue: ""
        };
        return value.otherValue;
      },
      set(newControlValue) {
        if (this.controlValueOther != newControlValue) {
          const newValue = {
            value: this.controlValue,
            otherValue: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newValue
          });
        }
      }
    },
    controlValueText() {
      if(this.controlValue != "Other" &&
        this.controlValue &&
        Array.isArray(this.controlValue))
        return this.controlValue.join(", ")
      
      if(this.controlValueOther)
        return this.controlValueOther

      return this.controlValue
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    controlValueOther(newValue) {
      if (newValue != this.localValueOther) {
        this.localValueOther = newValue;
      }
    }
  }
};
</script>

<style>
.dropdown-fb-control .vs__dropdown-toggle {
  background-color: var(--bg-color) !important;
}
</style>
